/**
 * MVP outreach credentials — email as username, hardcoded passwords.
 * Not for production security; dev/MVP only.
 */

export const OUTREACH_SESSION_KEY = "outreach_session_email";

export const OUTREACH_USERS = {
  "nadulanisith1.0@gmail.com": {
    name: "Nadula Nisith",
    password: "BTUI3B31AA",
  },
  "induwarathisarindu2010@gmail.com": {
    name: "Induwara Thisarindu",
    password: "BTUIBA460B",
  },
  "shasvinthsrikanth13@gmail.com": {
    name: "Shasvinth Srikanth",
    password: "BTUI9803E4",
  },
  "afthab.afti@gmail.com": {
    name: "Afthab Ahamed",
    password: "BTUI043768",
  },
  "sarrishiekanayake@gmail.com": {
    name: "Rihan Ekanayake",
    password: "BTUID72193",
  },
  "trandinu@icloud.com": {
    name: "Thisara Randinu",
    password: "BTUI3360B4",
  },
  "krishaniranaweera@gmail.com": {
    name: "Binal Yensith",
    password: "BTUI33EE51",
  },
  "induwanupeshala@gmail.com": {
    name: "Induwan Upeshala",
    password: "BTUI49167B",
  },
  "risajamahalla@gmail.com": {
    name: "Risaja Bathila",
    password: "BTUI2B112D",
  },
  "mkavishtharan@gmail.com": {
    name: "Kavishtharan Manoharan",
    password: "BTUI7124CC",
  },
  "sivagobisaru@gmail.com": {
    name: "Saarugesh Sivagobi",
    password: "BTUIA1E4BE",
  },
  "aaqilugail6@gmail.com": {
    name: "Aaqil Ugail",
    password: "BTUIB9A835",
  },
  "sasviduabeywardene@gmail.com": {
    name: "Ganidu Abeywardene",
    password: "BTUI53236F",
  },
  "mhzakirhassan@gmail.com": {
    name: "M.H.Zakir Hassan",
    password: "BTUI8CE4A5",
  },
  "dhammiwin@gmail.com": {
    name: "Sageeth Sathmika",
    password: "BTUI59EE57",
  },
  "munaf0122@gmail.com": {
    name: "M.Z.Abdul Munaf",
    password: "BTUI949B0D",
  },
  "sbhanukaprajapaksha@gmail.com": {
    name: "Bhanuka Rajapaksha",
    password: "BTUI9CAB75",
  },
  "samaranayakaradul@gmail.com": {
    name: "Radul Samaranayaka",
    password: "BTUI9A0CC3",
  },
  "thinugalakdinuu@gmail.com": {
    name: "Thinuga Lakdinu",
    password: "BTUI119634",
  },
  "hirooshae@gmail.com": {
    name: "Hiroosha Edirisinghe",
    password: "BTUI25EFF2",
  },
  "rkrurbanagsharan@gmail.com": {
    name: "Agsharan.K",
    password: "BTUI4529D7",
  },
  "janithkanchana247@gmail.com": {
    name: "Janith Kanchana",
    password: "BTUI7C390B",
  },
  "randeepanj@proton.me": {
    name: "Randeepa Jayasekara",
    password: "BTUI9F443A",
  },
};

/** Outreach admins — can view/edit all schools */
export const OUTREACH_ADMINS = new Set([
  "nadulanisith1.0@gmail.com",
  "induwarathisarindu2010@gmail.com",
  "afthab.afti@gmail.com",
  "admin@btui.com",
  "admin_main@rccsonline.com",
]);

export const MAX_SCHOOLS_PER_USER = 7;

export function normalizeEmail(email) {
  return (email ?? "").trim().toLowerCase();
}

export function validateOutreachLogin(email, password) {
  const key = normalizeEmail(email);
  const user = OUTREACH_USERS[key];
  if (!user || user.password !== password) {
    return null;
  }
  return {
    email: key,
    name: user.name,
    isAdmin: OUTREACH_ADMINS.has(key),
  };
}

export function getOutreachSession() {
  try {
    const email = normalizeEmail(localStorage.getItem(OUTREACH_SESSION_KEY));
    if (!email || !OUTREACH_USERS[email]) return null;
    return {
      email,
      name: OUTREACH_USERS[email].name,
      isAdmin: OUTREACH_ADMINS.has(email),
    };
  } catch {
    return null;
  }
}

export function setOutreachSession(email) {
  localStorage.setItem(OUTREACH_SESSION_KEY, normalizeEmail(email));
}

export function clearOutreachSession() {
  localStorage.removeItem(OUTREACH_SESSION_KEY);
}

export function getOutreachUserName(email) {
  const key = normalizeEmail(email);
  return OUTREACH_USERS[key]?.name ?? email;
}

/** All registered outreach volunteers (for admin team panel). */
export function getOutreachMemberList() {
  return Object.entries(OUTREACH_USERS).map(([email, { name }]) => ({
    email,
    name,
    isAdmin: OUTREACH_ADMINS.has(email),
  }));
}
